<template>
  <div class="wrap">
    <transition name="tip-wrap">
      <div class="tip-wrap" v-if="show">
        <div class="mask"/>
        <div class="box">
          <div class="title">
            系统提示
          </div>
          <div class="content">
            <div>请使用森果批发易、森果货主帮、森果开票助手、森果产地通APP</div>
            <div>{{text}}</div>
          </div>
          <div class="confirm" @click="close">
            确定
          </div>
        </div>   
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  props: {
    isBind: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
      show: false
    }
  },
  computed: {
    text() {
      return this.isBind? '更新头像昵称' : '绑定微信'
    }
  },
  methods: {
    open() {
      this.show = true
    },
    close() {
      this.show = false;
    }
  }
}
</script>

<style lang="scss" scoped>
.wrap {
  margin-top: 10px;
  position: relative;
  z-index: 100;
    .mask {
        position: fixed;
        left: 0;
        top: 0;
        right: 0;
        bottom: 0;
        background: rgba(0, 0, 0, .4);
        z-index: 99;
    }
    .box {
        position: fixed;
        left: 50%;
        top: 10px;
        width: 94%;
        max-width: 651px;
        padding: 10px;
        transform: translateX(-50%);
        background: #FFFFFF;
        border-radius: 10px;
        z-index: 100;
        color: #303133;
        font-weight: 600;
        .title {
            padding: 3px 0 13px;
            color: #08A681;
            font-size: 16px;
        }
        .content {
            text-align: center;
            height: 80px;
            display: flex;
            flex-direction: column;
            justify-content: center;
            line-height: 22px;
            font-size: 16px;
        }
        .confirm {
          position: relative;
          height: 35px;
          line-height: 35px;
          text-align: center;
          font-size: 14px;
          color: #606266;
        }
        .confirm::before {
          content: '';
          position: absolute;
          display: block;
          top: 0;
          left: 0;
          background: #C0C4CC;
          width: 100%;
          height: 2px;
          -webkit-transform: scaleY(0.5);
          transform: scaleY(0.5);
          -webkit-transform-origin: 0 0;
          transform-origin: 0 0;
        }
        
    }
}
.tip-wrap-enter,
.tip-wrap-leave-to {
  opacity: 0;
}

.tip-wrap-enter-active,
.tip-wrap-leave-active {
  transition: opacity .25s;
}
</style>

